export default __webpack_public_path__ + "static/media/header-logo-mobile.54c7863b.svg";